import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{ref:"snackbar",attrs:{"timeout":_vm.msg.timeout,"color":_vm.msg.color,"multi-line":_vm.msg.modo === 'multi-line',"vertical":_vm.msg.modo === 'vertical',"top":"","right":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.msg.text)}}),_c(VBtn,{attrs:{"dark":"","text":""},nativeOn:{"click":function($event){_vm.visible = false}}},[_vm._v("Cerrar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }